import styled from 'styled-components';

const TravelerListWrapper = styled.div`
.table-design {
    background: #FFFFFF;
    border: 1px solid #E7E9EB;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding: 10px 16px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    align-items: center;
    cursor: pointer;
    .round-box {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background-color: #6B47F5;
        .pi-check {
            font-size: .75em;
            color: rgba(255,255,255,.8);
            position: relative;
            top: -2px;
        }
    }
    .text1 {
        font-family: Bliss2;
        font-weight: 400;
        font-size: 13px;
        color: #818B9B;
    }
    .text2 {
        font-family: Bliss2;
        font-weight: 700;
        font-size: 13px;
        color: #6B47F5;
    }
}
.disabled-table {
    opacity: 0.5;
    border: 1px solid #E7E9EB;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
    cursor: not-allowed;
    .round-box {
        background-color: #818B9B !important;
    }
}
@media only screen and (min-width: 768px) {
    .col-md-4-width {
        width: 36.333333%;
        pi-pencil {
            color: #34A853;
        }
    }
    .col-md-3-width {
        width: 22%;
        border-left: 1px solid rgba(129, 139, 155, 0.2)!important;
    }
    .col-md-2-width {
        border-left: 1px solid rgba(129, 139, 155, 0.2)!important;
    }
}
@media only screen and (max-width: 575.99px) {
    .table-design {
        padding: 20px 8px 10px;
        align-items: start;
        .round-box {
            margin-top: 8px;
        }
    }
    .div-content1 {
        border-bottom: 1px solid rgba(129, 139, 155, 0.2)!important;
        padding-bottom: 8px;
    }
    .div-content2 {
        border-bottom: 1px solid rgba(129, 139, 155, 0.2)!important;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .div-content3, .div-content4 {
        padding-top: 8px;
        padding-bottom: 8px;
    }
}

`;

export default TravelerListWrapper;